import React, { useState, useEffect, useRef, useMemo } from "react";
import clsx from "clsx";
import { motion } from "framer-motion";

import { SliderSlickJourney } from "..";
import { dataJourney } from "../../constant";
import styles from "./styles.module.scss";

function Journey() {
  const refHeading = useRef();
  const refSlider = useRef();
  const [elTopHeading, setElTopHeading] = useState(0);
  const [elTopSlider, setElTopSlider] = useState(0);
  const [showElHeading, setShowElHeading] = useState(false);
  const [showElSlider, setShowElSlider] = useState(false);
  const [startingPoint, setStartingPoint] = useState(0);

  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: 0.5,
        },
      },
    }),
    []
  );
  const variantContent = useMemo(
    () => ({
      offScreen: { y: 70, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1,
          staggerChildren: 0.3,
        },
      },
    }),
    []
  );
  const variantSlider = useMemo(
    () => ({
      offScreen: { y: 100, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1,
          delay: 1,
        },
      },
    }),
    []
  );

  const checkScrollCondition = () => {
    if (
      window.pageYOffset > 0 &&
      elTopHeading > 0 &&
      window.pageYOffset + startingPoint > elTopHeading
    ) {
      setShowElHeading(true);
    } else {
      setShowElHeading(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopSlider > 0 &&
      window.pageYOffset + startingPoint > elTopSlider
    ) {
      setShowElSlider(true);
    } else {
      setShowElSlider(false);
    }
  };

  useEffect(() => {
    const setValues = () => {
      setStartingPoint(window.innerHeight * 0.85);
      if (refHeading.current) setElTopHeading(refHeading.current.offsetTop);
      if (refSlider.current) setElTopSlider(refSlider.current.offsetTop);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [refHeading, refSlider]);

  // useEffect(() => {
  //   console.log(showElement);
  // }, [showElement]);

  useEffect(() => {
    document.addEventListener("scroll", checkScrollCondition, {
      passive: true,
    });

    return () => {
      document.removeEventListener("scroll", checkScrollCondition, {
        passive: true,
      });
    };
  });

  return (
    <div className={clsx("mt-12", styles.journey)}>
      <motion.div
        ref={refHeading}
        variants={variantContainer}
        initial="offScreen"
        whileInView={showElHeading ? "onScreen" : "offScreen"}
        // viewport={{ once: true }}
        className={clsx("overflow-hidden", styles.container)}
      >
        <motion.h2
          variants={variantContent}
          className="headline-remo text-4xl lg:text-5xl text-center"
        >
          Our Journey
        </motion.h2>
        {/* <motion.p
          variants={variantContent}
          className="mt-8 mx-auto w-4/5 lg:w-3/5 text-base lg:text-xl text-center"
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </motion.p> */}
        <div className="mt:4 lg:mt-6">
          <motion.div
            ref={refSlider}
            variants={variantSlider}
            initial="offScreen"
            whileInView={showElSlider ? "onScreen" : "offScreen"}
            className="py-8"
          >
            <SliderSlickJourney data={dataJourney} showElement={showElSlider} />
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}

export default Journey;
